export default __webpack_public_path__ + "static/media/logo-small.7fa0fa2a.svg";